import { j as i, T as Ae, B as ir } from "./Spinner-yxPaS-Vf.js";
import sr, { forwardRef as lr, useRef as P, useState as ur, useCallback as c, useImperativeHandle as cr, useEffect as Fe } from "react";
import dr from "focus-trap-react";
import vr from "react-dom";
import { C as Pe, R as qe } from "./Row-sdSXGr8k.js";
import { b as fr, c as mr, a as hr } from "./Carousel-mirBhBrc.js";
import { styled as b, css as pe } from "styled-components";
import { c as Qe } from "./Container.utils-zmerNVMS.js";
import { z as gr, f as le, e as G, a as pr, d as xr } from "./index-tc-On6zr.js";
import { j as Ge, c as De, d as Xe, a as ue, B as ce, s as wr, T as We } from "./style-ImpGK6sv.js";
import { T as Ne } from "./typography.styled-F4iuH4S1.js";
import { R as yr } from "./RangeSlider-UEtWvwxX.js";
import { I as $r } from "./Image-TG_H-4vb.js";
import { D as br } from "./domPurify-ugx5Lmst.js";
import { g as jr } from "./_commonjsHelpers-OnjxAlhP.js";
import { u as Cr } from "./useTransitionState-9D4Z4_FK.js";
import { u as Tr } from "./useCarouselContext-LshUqZeh.js";
import { u as Pr, a as Dr } from "./useElementRefById-afvP7SGi.js";
import { u as Rr } from "./useAddBodyClass-J7-kOyEU.js";
import { P as _r } from "./PreventBodyOverflow-4Tam5bLu.js";
const Er = b.div`
  position: fixed;
  inset: 0;
  z-index: ${gr.modal};
  overflow-y: auto;

  *,
  & {
    box-sizing: border-box;
  }
`, Mr = b.div`
  ${Ge("opacity")}

  position: fixed;
  inset: 0;
  opacity: ${({ $isVisible: t }) => t ? 1 : 0};
  background: ${De.greyAlpha80};
`, Zr = b.div.attrs({
  $justifyContent: "flex-start",
  $flexDirection: "column"
})`
  transform: ${({ $isOpen: t }) => t ? "scale(1)" : "scale(0.7)"};
  opacity: ${({ $isOpen: t }) => t ? 1 : 0};
  width: 100%;
  height: 100vh;
  ${le}
  ${Ge("transform, opacity")}
`, kr = b.div.attrs({
  $justifyContent: "space-between",
  $alignItems: "center",
  $fluid: !0
})`
  ${Qe}

  padding: ${G.spacer2} 0;
  width: 100%;
  ${Xe("background-color", "accent")};
  ${Xe("color", "dominant")};

  ${le}
`, Br = b.div.attrs({
  $flexDirection: "column",
  $alignItems: "stretch"
})`
  ${le}

  height: 100%;

  ${ue(ce.sm, Qe)}
`, Or = b(Pe)`
  height: 100%;
`, He = b(qe).attrs({ $alignItems: "center" })`
  padding: 0 ${G.spacer3};

  ${ue(
  ce.xl,
  pe`
      padding: 0;
    `
)}
`, Lr = b(He).attrs({ $alignItems: "center", $flexGrow: "1" })`
  ${pr}

  border-radius: ${xr.md};
  background: ${De.white};
  padding-top: ${G.spacer5};
  overflow-x: hidden;
  pointer-events: auto;

  ${ue(
  ce.xl,
  pe`
      padding-top: ${G.spacer6};
    `
)}
`, zr = b(Ne)`
  margin: ${G.spacer3} 0;
  color: ${De.white};
`, Sr = b(Ne)`
  display: none;

  ${ue(
  ce.xl,
  pe`
      display: flex;
      flex: 1;
    `
)}
`, Ir = b.div.attrs({ $alignItems: "flex-start" })`
  ${le}

  flex: 1 1 auto;
  overflow: hidden;
`;
var Q = function() {
  return Q = Object.assign || function(t) {
    for (var f, h = 1, d = arguments.length; h < d; h++) {
      f = arguments[h];
      for (var u in f)
        Object.prototype.hasOwnProperty.call(f, u) && (t[u] = f[u]);
    }
    return t;
  }, Q.apply(this, arguments);
}, Yr = function(t, f) {
  var h = {};
  for (var d in t)
    Object.prototype.hasOwnProperty.call(t, d) && f.indexOf(d) < 0 && (h[d] = t[d]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, d = Object.getOwnPropertySymbols(t); u < d.length; u++)
      f.indexOf(d[u]) < 0 && Object.prototype.propertyIsEnumerable.call(t, d[u]) && (h[d[u]] = t[d[u]]);
  return h;
}, Te = [0, 0], Ve = "auto", Xr = lr(function(t, f) {
  var h = t.children, d = t.onPanChange, u = t.onZoomChange, w = t.minZoom, v = w === void 0 ? 1 : w, W = t.initialZoom, Y = W === void 0 ? 1 : W, N = t.maxZoom, m = N === void 0 ? 5 : N, B = t.scrollVelocity, H = B === void 0 ? 0.2 : B, X = t.animDuration, g = X === void 0 ? 0.25 : X, de = t.doubleTouchMaxDelay, V = de === void 0 ? 300 : de, ve = t.decelerationDuration, U = ve === void 0 ? 750 : ve, ne = t.allowZoom, D = ne === void 0 ? !0 : ne, Re = t.allowPan, K = Re === void 0 ? !0 : Re, _e = t.allowTouchEvents, fe = _e === void 0 ? !1 : _e, Ee = t.allowParentPanning, Ue = Ee === void 0 ? !1 : Ee, Me = t.allowWheel, Ze = Me === void 0 ? !0 : Me, ke = t.ignoredMouseButtons, Be = ke === void 0 ? [] : ke, Oe = Yr(
    t,
    ["children", "onPanChange", "onZoomChange", "minZoom", "initialZoom", "maxZoom", "scrollVelocity", "animDuration", "doubleTouchMaxDelay", "decelerationDuration", "allowZoom", "allowPan", "allowTouchEvents", "allowParentPanning", "allowWheel", "ignoredMouseButtons"]
  ), R = P(null), A = P(), Le = P(), ze = P(), k = P(), J = P(), ee = P(), z = P(), C = P(Y), y = P(Te), xe = P(g), Se = ur(Ve), Ke = Se[0], oe = Se[1], re = c(function() {
    R.current && (R.current.style.transition = "transform ease-out ".concat(xe.current, "s"), R.current.style.transform = "translate3d(".concat(y.current[0], "px, ").concat(y.current[1], "px, 0) scale(").concat(C.current, ")"));
  }, []), j = c(function(e) {
    C.current = e, re(), u && u(e);
  }, [re, u]), p = c(function(e) {
    y.current = e, re(), d && d({ posX: e[0], posY: e[1] });
  }, [re, d]), $ = c(function(e) {
    xe.current = e, re();
  }, [re]), Je = c(function() {
    return C.current;
  }, []), er = c(function(e) {
    var o = y.current[0], r = y.current[1], n = C.current, a = n + e < m ? n + e : m;
    a !== n && (o = o * (a - 1) / (n > 1 ? n - 1 : n), r = r * (a - 1) / (n > 1 ? n - 1 : n)), j(a), p([o, r]), $(g);
  }, [j, p, $, g, m]), rr = c(function(e) {
    var o = y.current[0], r = y.current[1], n = C.current, a = n - e > v ? n - e : v;
    a !== n && (o = o * (a - 1) / (n - 1), r = r * (a - 1) / (n - 1)), j(a), p([o, r]), $(g);
  }, [j, p, $, g, v]), tr = c(function(e, o, r, n) {
    var a;
    if (R.current) {
      var s = y.current[0], l = y.current[1], x = ((a = R.current) === null || a === void 0 ? void 0 : a.parentNode).getBoundingClientRect(), T = C.current, _ = x.width / r, S = x.height / n, E = Math.min(_, S, m), M = R.current.getBoundingClientRect(), Z = [M.width / T / 2, M.height / T / 2], O = Z[0], q = Z[1], L = [e + r / 2, o + n / 2], I = L[0], ar = L[1];
      s = (O - I) * E, l = (q - ar) * E, j(E), p([s, l]), $(g);
    }
  }, [j, p, $, g, m]), te = c(function(e, o, r) {
    var n = [C.current, y.current[0], y.current[1]], a = n[0], s = n[1], l = n[2];
    if (r === 1 || !R.current)
      return [0, 0];
    if (r > a) {
      var x = R.current.getBoundingClientRect(), T = [x.width / 2, x.height / 2], _ = T[0], S = T[1], E = [e - x.left - window.pageXOffset, o - x.top - window.pageYOffset], M = E[0], Z = E[1], O = [(_ - M) / a, (S - Z) / a], q = O[0], L = O[1], I = r - a;
      return [s + q * I, l + L * I];
    } else
      return [s * (r - 1) / (a - 1), l * (r - 1) / (a - 1)];
  }, []), me = c(function(e, o) {
    var r = m;
    p(te(e, o, r)), j(r), $(g);
  }, [p, j, $, te, g, m]), we = c(function(e, o, r, n, a) {
    if (e > 0) {
      if (n > o)
        return 0;
      if (n + e > o)
        return o - n;
    } else if (e < 0) {
      if (a < r)
        return 0;
      if (a + e < r)
        return r - a;
    }
    return e;
  }, []), Ie = c(function(e, o) {
    return e && o ? "move" : e ? "ew-resize" : o ? "ns-resize" : "auto";
  }, []), F = c(function(e, o, r) {
    if (r === void 0 && (r = 0), !!R.current) {
      var n = y.current[0], a = y.current[1], s = R.current.getBoundingClientRect(), l = R.current.parentNode.getBoundingClientRect(), x = [
        // Check if the element is larger than its container
        s.width > l.right - l.left,
        // Check if the element is out its container left boundary
        e > 0 && s.left - l.left < 0,
        // Check if the element is out its container right boundary
        e < 0 && s.right - l.right > 0
      ], T = x[0], _ = x[1], S = x[2], E = T || _ || S;
      E && (n += we(e, l.left, l.right, s.left, s.right));
      var M = [
        // Check if the element is higher than its container
        s.height > l.bottom - l.top,
        // Check if the element is out its container top boundary
        o > 0 && s.top - l.top < 0,
        // Check if the element is out its container bottom boundary
        o < 0 && s.bottom - l.bottom > 0
      ], Z = M[0], O = M[1], q = M[2], L = Z || O || q;
      L && (a += we(o, l.top, l.bottom, s.top, s.bottom));
      var I = Ie(E, L);
      p([n, a]), oe(I), $(r);
    }
  }, [p, oe, $, Ie, we]), Ye = c(function() {
    var e, o, r = (/* @__PURE__ */ new Date()).getTime(), n = r - ((e = Le.current) !== null && e !== void 0 ? e : 0) < V && r - ((o = ze.current) !== null && o !== void 0 ? o : 0) > V;
    return n ? (ze.current = r, !0) : (Le.current = r, !1);
  }, [V]), he = c(function(e, o) {
    var r = null, n = function(a) {
      r === null && (r = a);
      var s = a - r, l = (U - s) / U, x = [e * l, o * l], T = x[0], _ = x[1];
      s < U && Math.max(Math.abs(T), Math.abs(_)) > 1 ? (F(T, _, 0), A.current = requestAnimationFrame(n)) : A.current = null;
    };
    A.current = requestAnimationFrame(n);
  }, [F, U]), ae = c(function() {
    j(Y), oe(Ve), $(g), p(Te);
  }, [j, oe, $, p, Y, g]), nr = c(function(e) {
    e.preventDefault(), D && (C.current === v ? me(e.pageX, e.pageY) : ae());
  }, [me, ae, D, v]), ye = c(function(e) {
    if (e.preventDefault(), !(!D || !Ze)) {
      var o = -e.deltaY * H / 100, r = Math.max(Math.min(C.current + o, m), v), n = y.current;
      r !== C.current && (n = r !== v ? te(e.pageX, e.pageY, r) : Te), j(r), p(n), $(0.05);
    }
  }, [te, j, p, $, D, Ze, m, v, H]), $e = c(function(e) {
    e.preventDefault(), !(!K || Be.includes(e.button)) && (A.current && cancelAnimationFrame(A.current), ee.current = [e.pageX, e.pageY]);
  }, [K, Be]), be = c(function(e) {
    if (e.preventDefault(), !(!K || !ee.current)) {
      var o = [e.pageX, e.pageY], r = o[0], n = o[1], a = r - ee.current[0], s = n - ee.current[1];
      F(a, s, 0), ee.current = [r, n], k.current = [a, s];
    }
  }, [F, K]), ie = c(function(e) {
    e.preventDefault(), k.current && (he(k.current[0], k.current[1]), k.current = null), ee.current = null, oe("auto");
  }, [he]), je = c(function(e) {
    var o = Ye(), r = e.touches.length > 1;
    fe || e.preventDefault(), A.current && cancelAnimationFrame(A.current);
    var n = [e.touches[0].pageX, e.touches[0].pageY], a = n[0], s = n[1];
    if (r) {
      z.current = [a, s];
      return;
    }
    if (o && D) {
      C.current === v ? me(a, s) : ae();
      return;
    }
    K && (z.current = [a, s]);
  }, [
    me,
    ae,
    Ye,
    D,
    fe,
    K,
    v
  ]), Ce = c(function(e) {
    if (fe || e.preventDefault(), !!z.current) {
      if (e.touches.length === 1) {
        var o = [e.touches[0].pageX, e.touches[0].pageY], r = o[0], n = o[1], a = r - z.current[0], s = n - z.current[1];
        F(a, s), k.current = [a, s], z.current = [r, n], J.current = null;
      } else if (e.touches.length > 1) {
        var l = C.current, x = [e.touches[0].pageX, e.touches[0].pageY], T = x[0], _ = x[1], S = [e.touches[1].pageX, e.touches[1].pageY], E = S[0], M = S[1], Z = Math.sqrt(Math.pow(E - T, 2) + Math.pow(M - _, 2));
        if (J.current && Z && Z !== J.current) {
          D && (l += (Z - J.current) / 100, l > m ? l = m : l < v && (l = v));
          var O = [(T + E) / 2, (_ + M) / 2], q = O[0], L = O[1], I = te(q, L, l);
          j(l), p(I), $(0);
        }
        z.current = [T, _], J.current = Z;
      }
    }
  }, [
    te,
    F,
    p,
    $,
    j,
    D,
    fe,
    m,
    v
  ]), se = c(function() {
    k.current && (he(k.current[0], k.current[1]), k.current = null), z.current = null, J.current = null;
  }, [he]);
  cr(f, function() {
    return {
      getZoom: Je,
      zoomIn: er,
      reset: ae,
      move: F,
      zoomOut: rr,
      zoomToZone: tr,
      setZoom: j,
      setPos: p
    };
  }), Fe(function() {
    var e = R.current, o = window.matchMedia("(pointer: fine)").matches;
    return e == null || e.addEventListener("wheel", ye, { passive: !1 }), o ? (e == null || e.addEventListener("mousedown", $e, { passive: !1 }), e == null || e.addEventListener("mousemove", be, { passive: !1 }), e == null || e.addEventListener("mouseup", ie, { passive: !1 }), e == null || e.addEventListener("mouseleave", ie, { passive: !1 })) : (e == null || e.addEventListener("touchstart", je, { passive: !1 }), e == null || e.addEventListener("touchmove", Ce, { passive: !1 }), e == null || e.addEventListener("touchend", se, { passive: !1 }), e == null || e.addEventListener("touchcancel", se, { passive: !1 })), function() {
      e == null || e.removeEventListener("wheel", ye), o ? (e == null || e.removeEventListener("mousedown", $e), e == null || e.removeEventListener("mousemove", be), e == null || e.removeEventListener("mouseup", ie), e == null || e.removeEventListener("mouseleave", ie)) : (e == null || e.removeEventListener("touchstart", je), e == null || e.removeEventListener("touchmove", Ce), e == null || e.removeEventListener("touchend", se), e == null || e.removeEventListener("touchcancel", se));
    };
  }, [
    ye,
    $e,
    be,
    ie,
    je,
    Ce,
    se
  ]);
  var or = Q(Q({}, Oe), { ref: R, onDoubleClick: nr, style: Q(Q({}, Oe.style), { cursor: Ke, willChange: "transform", transition: "transform ease-out ".concat(xe.current, "s"), touchAction: Ue && C.current === 1 ? "pan-x pan-y" : "none", transform: "translate3d(".concat(y.current[0], "px, ").concat(y.current[1], "px, 0) scale(").concat(C.current, ")") }) });
  return i.jsx("div", Q({}, or, { children: h }));
});
const Vr = b.div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
`, Ar = b.div.attrs({ $flexDirection: "column", $alignItems: "stretch" })`
  height: 100%;
  ${le}
`, Fr = b($r)`
  cursor: move;
  ${wr("100%")}
`, qr = b(yr)`
  padding: ${G.spacer5} 0;

  ${ue(
  ce.xl,
  pe`
      padding: ${G.spacer6} 0;
    `
)}
`, Qr = b(Xr)`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  overflow: hidden;
`, ge = 1, Gr = ({
  images: t,
  rangeSliderAriaLabel: f,
  incrementAriaLabel: h,
  decrementAriaLabel: d,
  onChange: u
}) => {
  const w = P(null), v = P(null), W = (m) => {
    var B;
    (B = v == null ? void 0 : v.current) == null || B.setValue(Number(m.toFixed(1))), u && u(m);
  }, Y = (m, B) => {
    var X, g;
    const H = ((X = w == null ? void 0 : w.current) == null ? void 0 : X.getZoom()) || ge;
    (g = w == null ? void 0 : w.current) == null || g.zoomIn(Number(B.toFixed(1)) - H);
  }, N = {
    xs: {
      src: t.src,
      maxHeight: 5e3,
      maxWidth: 5e3,
      alt: t.alt
    }
  };
  return /* @__PURE__ */ i.jsxs(Ar, { children: [
    /* @__PURE__ */ i.jsx(Vr, { children: /* @__PURE__ */ i.jsx(
      Qr,
      {
        ref: w,
        "data-qa": "image-gallery",
        initialZoom: ge,
        maxZoom: 3,
        minZoom: ge,
        onZoomChange: W,
        children: /* @__PURE__ */ i.jsx(Fr, { alt: t.alt || "", images: N, objectFit: "contain" })
      }
    ) }),
    /* @__PURE__ */ i.jsx(qe, { children: /* @__PURE__ */ i.jsx(Pe, { $offset: { xs: 3, sm: 4 }, $col: { xs: 6, sm: 4 }, children: /* @__PURE__ */ i.jsx(
      qr,
      {
        ref: v,
        min: ge,
        max: 3,
        step: 0.1,
        rangeSliderAriaLabel: f,
        incrementAriaLabel: h,
        decrementAriaLabel: d,
        onChange: Y
      }
    ) }) })
  ] });
}, ht = ({
  quickViewRootId: t,
  children: f,
  title: h,
  theme: d,
  isOpen: u = !1,
  onClose: w,
  ariaLabel: v,
  closeButton: W,
  previousButtonAriaLabel: Y,
  nextButtonAriaLabel: N,
  slideDividerLabel: m,
  totalSlides: B,
  onChange: H,
  ...X
}) => {
  const g = Pr(t), [de, V, ve] = Cr(u, ["opacity"]), U = P(null);
  if (Fe(() => {
    var D;
    U.current = (D = jr().document) == null ? void 0 : D.getElementById(t);
  }, [t]), Dr(
    c(
      (D) => {
        D.key === "Escape" && u && w();
      },
      [w, u]
    )
  ), Rr(u, "modal-open"), !t || !g || !de && !V)
    return null;
  const ne = "quick-view-modal";
  return vr.createPortal(
    /* @__PURE__ */ i.jsxs(Ae, { theme: d, children: [
      /* @__PURE__ */ i.jsx(_r, { prevent: u }),
      /* @__PURE__ */ i.jsx(Er, { "data-qa": "quck-view", children: /* @__PURE__ */ i.jsxs(
        fr,
        {
          ...X,
          totalSlides: B ?? sr.Children.count(f),
          touchEnabled: !1,
          dragEnabled: !1,
          children: [
            /* @__PURE__ */ i.jsx(Mr, { onTransitionEnd: ve, $isVisible: V }),
            /* @__PURE__ */ i.jsx(
              dr,
              {
                active: !0,
                focusTrapOptions: {
                  fallbackFocus: `#${ne}`
                },
                children: /* @__PURE__ */ i.jsxs(Zr, { $isOpen: V, role: "dialog", "aria-label": v, id: ne, children: [
                  /* @__PURE__ */ i.jsx(
                    Wr,
                    {
                      title: h,
                      closeButton: W,
                      onClose: w,
                      previousButtonAriaLabel: Y,
                      nextButtonAriaLabel: N,
                      slideDividerLabel: m,
                      onChange: H
                    }
                  ),
                  /* @__PURE__ */ i.jsx(Ir, { children: /* @__PURE__ */ i.jsx(mr, { children: f }) })
                ] })
              }
            )
          ]
        }
      ) })
    ] }),
    g
  );
}, Wr = ({
  title: t,
  closeButton: f,
  onClose: h,
  previousButtonAriaLabel: d,
  nextButtonAriaLabel: u,
  slideDividerLabel: w,
  onChange: v
}) => /* @__PURE__ */ i.jsx(Ae, { theme: "dark", children: /* @__PURE__ */ i.jsxs(kr, { children: [
  /* @__PURE__ */ i.jsx(Sr, { "data-qa": "quick-view-title", $variant: We.action, children: t }),
  /* @__PURE__ */ i.jsx(
    hr,
    {
      previousButtonAriaLabel: d,
      nextButtonAriaLabel: u,
      slideDividerLabel: w,
      onChange: v
    }
  ),
  /* @__PURE__ */ i.jsx("div", { style: { flex: 1, textAlign: "right" }, children: /* @__PURE__ */ i.jsx(ir, { variant: "secondary", onClick: h, children: f }) })
] }) }), gt = ({ description: t, onChange: f, ...h }) => {
  const { currentSlide: d } = Tr(), u = () => {
    f && f(d + 1);
  };
  return /* @__PURE__ */ i.jsxs(Br, { children: [
    /* @__PURE__ */ i.jsx(Lr, { children: /* @__PURE__ */ i.jsx(Or, { $offset: { lg: 2, sm: 1 }, $col: { xs: 12, sm: 10, lg: 8 }, children: /* @__PURE__ */ i.jsx(Gr, { ...h, onChange: u }) }) }),
    t && /* @__PURE__ */ i.jsx(He, { children: /* @__PURE__ */ i.jsx(Pe, { $offset: { lg: 2 }, $col: { xs: 12, lg: 8 }, children: /* @__PURE__ */ i.jsx(
      zr,
      {
        "data-qa": "quick-view-description",
        dangerouslySetInnerHTML: { __html: br(t, "inlineRichtext") },
        $textAlign: "center",
        $variant: We.bodyS,
        $textEllipsis: { xs: 10, sm: 3 }
      }
    ) }) })
  ] });
};
export {
  ht as Q,
  gt as a
};
